import React, { forwardRef } from "react";
import { useTranslation } from "react-i18next";

//CSS
import "./fileInputField.css";

//Components
import SvgNoteIcon from "../../SvgIcons/NoteIcon";

const FileInputField = forwardRef(function FileInputField(
  {
    fileName = null,
    onChange,
    accept,
    label,
    changeLabel,
    readOnly = false,
  },
  ref
) {
  const { t } = useTranslation();

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    if (onChange) onChange(selected || null);
  };

  return (
    <div className={`fileInputContainer${readOnly ? " readOnly" : ""}`}>
      <input
        ref={ref}
        type="file"
        accept={accept}
        onChange={handleFileChange}
        readOnly={readOnly}
        disabled={readOnly}
        className="fileInput"
      />
      <SvgNoteIcon className="fileInputIcon" />
      <p className="fileInputLabel">
        {fileName || label || t("Click to upload a file")}
      </p>
      {fileName ? (
        <div className="fileInputCover">
          <p className="fileInputLabel">
            {changeLabel || t("Click to change file")}
          </p>
        </div>
      ) : null}
    </div>
  );
});

export default FileInputField;
